import React from 'react';
import { HistoryEntry } from '../types';

interface SparklineProps {
  history: HistoryEntry[];
}

export default function Sparkline({ history }: SparklineProps) {
  if (!history || history.length < 2) return null;
  const bars = 20;
  const filled = history.slice(-bars);
  const empty = bars - filled.length;
  const items: (HistoryEntry | null)[] = [...Array(empty).fill(null), ...filled];

  return (
    <div style={{ display: 'flex', gap: '2px', alignItems: 'flex-end', height: '20px' }}>
      {items.map((h, i) => {
        const color = !h
          ? '#1e2030'
          : h.status === 'online'
          ? '#a8ff78'
          : h.status === 'degraded'
          ? '#ffcc44'
          : '#ff4444';
        return (
          <div
            key={i}
            style={{
              width: '4px',
              height: h ? '14px' : '6px',
              background: color,
              borderRadius: '2px',
              opacity: !h ? 0.4 : 1,
            }}
          />
        );
      })}
    </div>
  );
}
